import _ from 'underscore';

let i18n = null;

export function initialize(options) {
  ({ i18n } = options);
}

/**
 * Update delivery status setting for render it in category type in filter
 *
 * @param {Object} entitySchema - the option to update for filter
 * @returns {void}
*/
export function updateAuctionInsightPropertyForFilter(entitySchema) {
  const hasAuctionInsightOption = _.find(entitySchema.properties, prop => prop.name === 'HasAuctionInsight');

  _.extend(hasAuctionInsightOption, {
    operatorDisplayNameMap: { eq: i18n.getString('FilterLocalization_FilterOperator_MatchesAny_Equal') },
    localized: {
      true: i18n.getString('FilterLocalization_BooleanFilter_Available_1'),
      false: i18n.getString('FilterLocalization_BooleanFilter_Available_0'),
    },
    chooseType: 'select',
  });
}

